import PropTypes from 'prop-types';
import { TextInput } from 'jl-design-system/components/text-input/TextInput';

export const AddressQuestionInput = (props) => {
  const {
    input: { value = '', onChange, onBlur, name },
    meta = {},
    ...restProps
  } = props;

  const { touched, error } = meta;
  const showError = touched && error;

  return (
    <TextInput
      {...restProps}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={showError ? error : undefined}
    />
  );
};

AddressQuestionInput.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};
